export * from "./getCookieConfig";
export * from "./getXpsConfig";
export * from "./getDefaultXpsConfig";
